import React from 'react';

import './empty-list.css';

const EmptyList = () => (<div className="resource-dialog__resources-list_empty">
  Folder is empty. Please upload the file to be inserted.
</div>);

export default EmptyList;